// get default data from config file
import configData from '../../config'
// get string parser
import * as fqParser from '../reusable/fq-parser'

const dataSearchDefault = configData().params.search.default

const state = {
  filters: {
    fields: {}
  },
  filterParams: [],
  filterParamsStatic: [],
  filterBox: false,
  isFilterBoxSet: false
}

const getters = {
  GET_FILTER_BOX: state => {
    return state.filterBox
  },
  GET_IS_FILTER_BOX: state => {
    return state.isFilterBoxSet
  },
  GET_FILTERS_FIELDS: state => {
    return state.filters.fields
  },
  GET_FILTER_PARAMS: state => {
    return state.filterParams
  },
  GET_FILTER_PARAMS_STATIC: state => {
    return state.filterParamsStatic
  },
  GET_FILTER_PARAMS_BY_NAME: state => (name) => {
    return state.filterParams.filter(obj => obj.name == name)[0]
  }
}

const actions = {
}

const mutations = {
  SET_FILTERS: (state, { list }) => {
    // set chosen filters from ajax response
    state.filters.fields = list.facet_fields
  },

  SET_FILTER_PARAMS: (state, obj) => {
    state.filterParams.forEach(function(value) {
      // checks if filter already exists in previously chosen filters
      if (value.name == obj.name) {
        let index = state.filterParams.findIndex(i => i.name === value.name);
        // removes existing filter
        state.filterParams.splice(index, 1);
      }
    })
    // if subfilters are checked pushes them to filter params
    if (obj.filters.length > 0) {
      state.filterParams.push(obj)
    }
  },

  SET_FILTER_BOX: (state, box) => {
    // set active filterbox
    state.filterBox = box
  },

  SET_IS_FILTER_BOX: (state, box) => {
    state.isFilterBoxSet = box
  },

  RESET_FILTER_PARAMS: (state) => {
    state.filterParams = []
    state.filterParamsStatic = []
  },

  SET_FILTER_PARAMS_RES: (state, data) => {
    state.filterParams = []
    state.filterParamsStatic = []

    let fq = data.responseHeader.params.fq

    function pushFilter(value) {
      // check if it is regular filter
      let name = fqParser.parseResStringName(value)
      if (name != 'date') {
        let obj = fqParser.parseResString(value, name)
        state.filterParams.push(obj)
        state.filterParamsStatic.push(obj)
      }
    }

    if (typeof fq !== typeof undefined) {
      if (typeof fq !== 'string') {
        fq.forEach(function(value) {
          pushFilter(value)
        })
      } else {
        pushFilter(fq)
      }
    }
  }
}

export {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js